/**
 * @generated SignedSource<<7d49efc0e49ac88b2540c996ce004270>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditFachberaterRewardConfigurationForm_MakeFachberaterRewardConfigurationFragment$data = {
  readonly certificateTemplateRef: string;
  readonly id: string;
  readonly " $fragmentType": "EditFachberaterRewardConfigurationForm_MakeFachberaterRewardConfigurationFragment";
};
export type EditFachberaterRewardConfigurationForm_MakeFachberaterRewardConfigurationFragment$key = {
  readonly " $data"?: EditFachberaterRewardConfigurationForm_MakeFachberaterRewardConfigurationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditFachberaterRewardConfigurationForm_MakeFachberaterRewardConfigurationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditFachberaterRewardConfigurationForm_MakeFachberaterRewardConfigurationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "certificateTemplateRef",
      "storageKey": null
    }
  ],
  "type": "MakeFachberaterRewardConfiguration",
  "abstractKey": null
};

(node as any).hash = "47421b3cad6f1e8ed213853d562ef70c";

export default node;
